import { useCallback, useEffect, useRef, useState } from 'react';

export const useDeviceShake = () => {
  const [isStill, setIsStill] = useState(true);
  const lastReadings = useRef<number[]>([0, 0, 0]);
  const lastUpdate = useRef<number>(0);
  const shakeTimeout = useRef<number | null>(null);

  const handleDeviceMotion = useCallback((event: DeviceMotionEvent) => {
    const acceleration = event.accelerationIncludingGravity;
    if (!acceleration) return;

    const currentTime = new Date().getTime();
    const timeDifference = currentTime - lastUpdate.current;

    if (timeDifference > 100) {
      const threshold = 2.5;
      const x = acceleration.x ?? 0;
      const y = acceleration.y ?? 0;
      const z = acceleration.z ?? 0;

      const deltaX = Math.abs(x - lastReadings.current[0]);
      const deltaY = Math.abs(y - lastReadings.current[1]);
      const deltaZ = Math.abs(z - lastReadings.current[2]);

      lastReadings.current = [x, y, z];
      lastUpdate.current = currentTime;

      if (deltaX > threshold || deltaY > threshold || deltaZ > threshold) {
        setIsStill(false);

        if (shakeTimeout.current) {
          window.clearTimeout(shakeTimeout.current);
        }

        shakeTimeout.current = window.setTimeout(() => {
          setIsStill(true);
          shakeTimeout.current = null;
        }, 1000);
      }
    }
  }, []);

  useEffect(() => {
    window.addEventListener('devicemotion', handleDeviceMotion);

    return () => {
      window.removeEventListener('devicemotion', handleDeviceMotion);
      if (shakeTimeout.current) {
        window.clearTimeout(shakeTimeout.current);
      }
    };
  }, [handleDeviceMotion]);

  return {
    isStill,
  };
};
